/*

    Select.
    Есть клавиатура

    при создании объекта, надо создать пропсы:
    
        cnSelect - className TextBox
        value - значение по умолчанию
        onChange - событие для изменения значения
*/


import './Select.css';
import { useState, useEffect } from 'react'
import unique from '../modules/unique';



function Select(props) {
 

    const [options, SetOptions] = useState("");                             // список
    const [is_entering_select, SetEnteringSelect] = useState("");           // true, если показывать модальное окно ввода текста
    const [cnSelect, SetCNSelect] = useState("");                           // класс TextBox
    
    
    useEffect(() => { SetCNSelect(props.cnSelect) }, [props.cnSelect]);
    useEffect(() => { FillOptions(props.options) }, [props.options]);


  return (      

    <>
        <div className={ cnSelect } onClick={ () => SetEnteringSelect(true) }>{ props.value.label }</div>
        { is_entering_select && (
          <div className="wrap">
              <div className="modal">

                <div className="caption">{ props.caption }</div>
                <div className="textboxgrid">
                    { options }
                </div>

                <br /> <br />

                <div className="container-fluid">
                    <button type="button" className="btn btn-warning btn-lg result" onClick={ () => { SetEnteringSelect(false) } }>Отмена</button>
                </div>

              </div>            
          </div>
        )}
    </>
  );


  function FillOptions(list)
  {
        var res = [];
        for(let i in list)        
            res.push(<div key={ unique() } className="one-select" value={ list[i].value } onClick={ () => { Success(list[i]) } }>{ list[i].label }</div>);
        SetOptions(res);        
  }


    function Success(selected)
    {
        if(props.onChange !== undefined && props.onChange != null) props.onChange(selected);
        SetEnteringSelect(false);
    }


}

export default Select;
